import { CombinationOperator } from 'minisearch';
import { useEffect, useState } from 'react';
import { useMiniSearch } from 'react-minisearch';

export const useSearch = <T>({ items }: { items: T[] | undefined }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredItems, setFilteredItems] = useState(items ?? []);

  const miniSearchOptions = {
    fields: ['name'],
    searchOptions: { prefix: true, fuzzy: true, combineWith: 'AND' as CombinationOperator }
  };
  const { search, searchResults, addAll, removeAll } = useMiniSearch(
    items ?? [],
    miniSearchOptions
  );

  const handleSearchChange = (event: any) => setSearchTerm(event.target.value);

  // Search items may be loaded, added, deleted, edited. Need to be able
  // to reflect all of these potential changes. Unfortunately very non-performant
  useEffect(() => {
    if (items) {
      removeAll();
      addAll(items);
    }
  }, [items]);

  useEffect(() => {
    search(searchTerm);
  }, [searchTerm]);

  // Apply search bar results to filter items out
  useEffect(() => {
    if (searchTerm) {
      setFilteredItems(searchResults ?? []); // empty search result results in empty item list
    } else {
      // Reset to all items if search bar is empty
      setFilteredItems(items ?? []);
    }
  }, [searchResults, items]);

  return {
    searchTerm,
    filteredItems,
    handleSearchChange,
    setSearchTerm
  };
};
